import InputLabel from '@material-ui/core/InputLabel'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
`
export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.extraBold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 24px;
`

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
  min-width: 248px;
`
